import instance from './axios'

//获取账户信息接口
export const profile = (para) => {
  return instance.get('/account/profile', {params: para})
}
//登出接口
export const logout = (para) => {
  return instance.post('/account/logout', para)
}

